import { c } from 'react-compiler-runtime';
import { useContext } from 'react';
import { FeatureFlagContext } from './FeatureFlagContext.js';
import { FeatureFlagScope } from './FeatureFlagScope.js';
import { jsx } from 'react/jsx-runtime';

function FeatureFlags(t0) {
  const $ = c(6);
  const {
    children,
    flags
  } = t0;
  const parentFeatureFlags = useContext(FeatureFlagContext);
  let t1;
  if ($[0] !== flags || $[1] !== parentFeatureFlags) {
    t1 = FeatureFlagScope.merge(parentFeatureFlags, FeatureFlagScope.create(flags));
    $[0] = flags;
    $[1] = parentFeatureFlags;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const scope = t1;
  const value = scope;
  let t2;
  if ($[3] !== children || $[4] !== value) {
    t2 = /*#__PURE__*/jsx(FeatureFlagContext.Provider, {
      value: value,
      children: children
    });
    $[3] = children;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}

export { FeatureFlags };
